import { InputLabel } from '@mui/material'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { Dayjs } from 'dayjs'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'

import ModalActionContainer from 'components/containers/modalActionContainer'
import DatePickerForm from 'components/parts/forms/datePickerForm'
import { helper } from 'helper'

interface Props {
  onCancel: () => void
  onSave: (data: { year: number; month: number; expire: Dayjs }) => void
}

interface Form {
  submitDate: Dayjs
  expireDate: Dayjs
}

export default function ShiftQuestionnaireModal(props: Props) {
  const today = helper.day.today()
  const { control, handleSubmit } = useForm<Form>({
    defaultValues: {
      // 翌月
      submitDate: today.add(1, 'month'),

      // 月末
      expireDate: today.endOf('month'),
    },
  })
  const getControl = helper.control.valid(control)

  const formToData = (formValue: Form) => {
    if (formValue.expireDate.isBefore(today, 'day')) {
      alert('提出期限は今日以降にしてください')
      return
    }

    const data = {
      year: formValue.submitDate.year(),
      month: formValue.submitDate.month() + 1,

      // ~1日の終わり
      expire: formValue.expireDate.endOf('day').subtract(1, 'second'),
    }
    props.onSave(data)
  }

  return (
    <form onSubmit={handleSubmit(formToData)}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <InputLabel>提出期間</InputLabel>
          <Controller
            {...getControl('submitDate').c}
            render={({ field }) => (
              <DatePickerForm
                sx={datePickerStyle}
                format="YYYY年MM月分"
                openTo="month"
                views={['month']}
                {...field}
              />
            )}
          />
        </Grid>

        <Grid item xs={6}>
          <InputLabel>提出期限</InputLabel>
          <Controller
            {...getControl('expireDate').c}
            render={({ field }) => (
              <DatePickerForm
                sx={datePickerStyle}
                openTo="day"
                views={['month', 'day']}
                {...field}
              />
            )}
          />
        </Grid>
      </Grid>

      <ModalActionContainer>
        <Button variant="negative" onClick={props.onCancel}>
          キャンセル
        </Button>
        <Button variant="contained" type="submit">
          一括送信
        </Button>
      </ModalActionContainer>
    </form>
  )
}

const datePickerStyle = {
  width: '100%',
}
